import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e5e0419c")

_pushScopeId("data-v-e5e0419c")
const _hoisted_1 = { class: "overlay top-countries" }
const _hoisted_2 = { class: "t-4 top-countries__title" }
const _hoisted_3 = { class: "top-countries__list" }
const _hoisted_4 = { class: "top-countries__flag" }
const _hoisted_5 = { class: "top-countries__name" }
const _hoisted_6 = { class: "top-countries__percentage" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QuesHint = _resolveComponent("QuesHint")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("span", null, _toDisplayString(_ctx.$t('pages.home.top10MonthCountry')), 1),
      _createVNode(_component_QuesHint, {
        title: _ctx.$t('touchbord.hintContentTop')
      }, null, 8, ["title"])
    ]),
    _createVNode("div", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.countries, (country, countryInd) => {
        return (_openBlock(), _createBlock("div", {
          key: countryInd,
          class: "top-countries__item"
        }, [
          _createVNode("div", _hoisted_4, [
            _createVNode("img", {
              src: 'https://api.eqonaq.kz/' + country.flag
            }, null, 8, ["src"])
          ]),
          _createVNode("div", _hoisted_5, _toDisplayString($setup.getCountryName(country)), 1),
          _createVNode("div", _hoisted_6, _toDisplayString(country.percentage), 1)
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
})